import * as React from "react"

// @ts-ignore
import cbsBannerLogo from "../../assets/cbs-banner-logo.svg"
// @ts-ignore
import hogstaLogo from "../../assets/hogsta-logo.png"
// @ts-ignore
import styles from "./Banner.module.scss"

export function Banner() {
  return (
    <div className={styles.Banner}>
      <div className={styles.bannerContainer}>
        <img className={styles.cbsLogo} src={cbsBannerLogo} alt='CBS banner logo' />
        <a href="https://www.uc.se/risksigill2?showorg=5568279367&language=swe" target="_blank" rel="noreferrer">
          <img className={styles.hogstaLogo} src={hogstaLogo} alt='Högsta Kreditvärdighet logo' />
        </a>
      </div>
    </div>
  )
}
